import { Combobox } from '@mantine/core'

import { formatPhone } from 'src/lib/phone.utils'

import ContactSourceBadge from './ContactSourceBadge'

interface ContactOptionProps {
  contact: {
    contactId: string
    contactName?: string
    phoneNumber?: string
    email?: string
    alternativePhones?: string[]
    dotNumber?: string
    source?: string
    status?: string
    occurrenceCount?: number
  }
  index: number
}

const ContactOption = ({ contact, index }: ContactOptionProps) => {
  return (
    <Combobox.Option
      className="flex flex-col"
      value={contact}
      key={`${contact.contactId}-${index}`}
    >
      <div className="flex items-center gap-2">
        <span className="flex-1 text-xs font-medium text-doubleNickel-gray-700">
          {contact.contactName || 'Unnamed Contact'}
        </span>
        {/* Every source has a label, so every contact says where it came from */}
        <ContactSourceBadge source={contact.source} />
      </div>
      {contact?.email && (
        <span className="flex-1 text-xs font-medium text-doubleNickel-gray-400">
          {contact?.email}
        </span>
      )}
      {contact?.phoneNumber && (
        <span className="flex-1 text-xs font-medium text-doubleNickel-gray-400">
          {formatPhone(contact.phoneNumber)}
        </span>
      )}
    </Combobox.Option>
  )
}

export default ContactOption
